// Centralized, typed configuration access.
//
// Precedence: RUNTIME config (window.__FINKIT_CONFIG__, set by /config.js — the
// appsettings.prod equivalent that is edited on the server and survives deploys)
// wins when it provides a non-empty value; otherwise we fall back to BUILD-TIME
// Vite env (used in dev via .env, and as a harmless default in prod). No hardcoded
// production URLs, tenant ids or secrets live in source (CLAUDE / prompt §8).

interface RuntimeConfig {
  apiBaseUrl?: string;
  tenant?: string;
}

// config.js runs before the app bundle; guard for SSR/tests where window is absent.
const runtime: RuntimeConfig =
  (typeof window !== 'undefined' &&
    (window as unknown as { __FINKIT_CONFIG__?: RuntimeConfig }).__FINKIT_CONFIG__) ||
  {};

// `||` (not `??`): an empty string from the template falls through to the Vite
// value, so a server that hasn't customised config.js still works in dev.
export const env = {
  // Empty string => use relative URLs (same origin; the Vite dev proxy handles routing).
  apiBaseUrl: (runtime.apiBaseUrl || import.meta.env.VITE_API_BASE_URL || '').replace(/\/+$/, ''),
  // Tenant to send as the __tenant header before login (dev / single-tenant host).
  tenant: (runtime.tenant || import.meta.env.VITE_TENANT || '').trim(),
} as const;
